import React          from 'react';
import ReactDom       from 'react-dom';

import Utils          from 'utils';
import Const          from 'fw_const';

import SubLoading     from 'sub_loading';
import ContentsModal  from 'contents_modal';

// import FacebookLogin from 'react-facebook-login';
// -------------------------------------------------------

class Index extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      modal    : false,
      userList : [],
      loading  : false,
    };
  }
  // -------------------------------------------------------
  
  componentDidMount(){
    setTimeout( function(){
      window.loginCallback = res => {
        FB.getLoginStatus(function(response) {
          this.loginAction.bind(this)(response);
        }.bind(this));
      }
    }.bind(this), 150);
  }
  // -------------------------------------------------------
  
  /*
   * コンストラクタ
   */
  loginAction(res) {
    Utils.request.bind(this)('/api/insight/login', { tokenData: res },
      function(res){
        console.log(res);
        if( this.props.refresh_ev != undefined ) this.props.refresh_ev.bind(this)();
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  responseFacebook(res) {
    console.log(res);
  }
  // -------------------------------------------------------
  
  /*
   * 出力処理
   */
  render() {
    return (
      <div>
        <SubLoading flg={this.state.loading} />
        
        <button onClick={this.loginAction.bind(this)}>Facebookでログイン</button>
      </div>
    )
  }
}
// -------------------------------------------------------

export default Index;